import { defineComponent, h } from "vue";
import { createRouter, createWebHistory } from "vue-router";

const RouteView = defineComponent({
  name: "RouteView",
  setup: () => () => h("span", { hidden: true }),
});

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: RouteView },
    { path: "/services", component: RouteView },
    { path: "/process", component: RouteView },
    { path: "/contact", component: RouteView },
    { path: "/privacy", component: RouteView },
    { path: "/:pathMatch(.*)*", component: RouteView },
  ],
  scrollBehavior: () => ({ top: 0 }),
});
